module.exports = __webpack_public_path__ + "img/bg1.c1e398d6.png";